import service from '@/lib/request'

const baseURL = '/api'

// 权限相关放这里
const MAPI = {
  // 获取无权限页面
  getRegionContact: (params) => service.post(`${baseURL}/getRegionContact.json`, params)
}

export default MAPI
